module.exports = __webpack_public_path__ + "media/images/gallery/aurorae_off-7ef66b0cce582ab30e1f018fc35c9a28.gif";